import React from 'react';
import { HeaderMainTitleContainer } from './Title.css.js';

const Title = (props) => {
  return (
    <HeaderMainTitleContainer className={props.mainTitle === '종합현황' ? 'headerMainTitle' : 'headerTitle'}>
      <div>
        <span>{props.mainTitle === '종합현황' ? <>풍속 모니터링 시스템</> : props.mainTitle}</span>
      </div>
    </HeaderMainTitleContainer>
  );
};

export default Title;
